import React from "react";
import { MenuItem } from "../hooks/useHeader";
import { Link } from "gatsby";
import { PhosphorIcon } from "../../PhosphorIcon/PhosphorIcon";
import { Icons } from "../../PhosphorIcon/types";

interface Props {
  item: MenuItem;
  handleOpenMenu: () => void;
}

export const MobileNavButton = ({ item, handleOpenMenu }: Props) => {
  return (
    <>
      {!item.subMenuElementMobile && (
        <Link
          className="Header__mobile_nav_button"
          to={item.link}
          target={item.target}
          onClick={handleOpenMenu}
        >
          {item.name}
          <div className="Header__nav_line" />
        </Link>
      )}
      {item.subMenuElementMobile && (
        <>
          <div
            className="Header__mobile_nav_button"
            onClick={item.handleOpenSubMenu}
          >
            <span
              style={{
                display: "flex",
                gap: "16px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {item.name}
              {item.openSubMenu ? (
                <PhosphorIcon icon={Icons.CaretUp} size={16} />
              ) : (
                <PhosphorIcon icon={Icons.CaretDown} size={16} />
              )}
            </span>
            <div className="Header__nav_line" />
          </div>
          {item.openSubMenu && item.subMenuElementMobile}
        </>
      )}
    </>
  );
};
